<div class="head">
  <p class="bold">{{ 'mercer-support.dialog.directs-pc-for-comparison' | translate }}</p>
</div>
<div class="directs-position-comparison-list">
  @for (position of comparisonEmployees; track position) {
    <div class="item">
      <div class="left">
        <coin-siemens-energy-employee-preview
          [small]="true"
          [showGid]="true"
          [employee]="position"></coin-siemens-energy-employee-preview>
      </div>
      <div class="right">
        @if (!!position?.positionClass) {
          <p class="position-class bold">PC {{ position?.positionClass }}</p>
        }
        @if (!position?.positionClass) {
          <p class="position-class missing bold">{{ 'mercer-support.dialog.no-pc' | translate }}</p>
        }
      </div>
    </div>
  }
  @if (!comparisonEmployees?.length) {
    <p>{{ 'mercer-support.dialog.no-positions' | translate }}</p>
  }
</div>
